import React, { useRef, useState } from "react";
import { SovosButton, SovosBox, SovosDrawerHeader, SovosButtonsGroup } from "mosaic-react";
import { AddCircleOutline, Upload } from "mosaic-react-icons";
import { UserRoles } from "../../enums/userRoles";
import { checkRolesByOrganizationProject } from "colbi_web_ui/lib/utils/roleValidator";
import DownloadTemplateDialog from "./DownloadTemplateDialog";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const UploadFormHeaderButtons = (props) => {
    const showLinearProgress = useRef(false);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const { pushNotification, uploadFiles } = useGlobalValue();
    const { filesList, pushModal, i18n, reload, projectId, user } = props;

    return (
        <>
            {checkRolesByOrganizationProject(user, projectId, [
                UserRoles.ADMIN,
                UserRoles.OWNER,
                UserRoles.WRITER,
                UserRoles.PP_SUPPORT,
                UserRoles.SUPPORT,
            ]) ? (
                <>
                    <DownloadTemplateDialog projectId={projectId} />

                    <SovosButton
                        disabled={uploadInProgress}
                        key="uploadFiles"
                        children={i18n`Upload`}
                        startIcon={<AddCircleOutline />}
                        onClick={() => {
                            pushModal({
                                view: `UploadFileForm`,
                                data: { filesList, showLinearProgress },
                                customHeaderButton: ({ pop, id }) => {
                                    return (
                                        <SovosBox sx={{ width: "100%" }}>
                                            <SovosDrawerHeader title={i18n`Upload`}>
                                                <SovosButtonsGroup align={"right"}>
                                                    <SovosButton
                                                        variant={"text"}
                                                        children={i18n`Cancel`}
                                                        onClick={() => pop && pop(id)}
                                                    />
                                                    <SovosButton
                                                        disabled={showLinearProgress?.current}
                                                        children={i18n`Upload`}
                                                        onClick={() => {
                                                            if (filesList.current?.length === 0) {
                                                                pushNotification({
                                                                    message: i18n`No file(s) selected to upload`,
                                                                    type: "error",
                                                                    open: true,
                                                                    timeout: "medium",
                                                                });
                                                                return;
                                                            }
                                                            showLinearProgress.current =
                                                                !showLinearProgress?.current;
                                                            setUploadInProgress(true);
                                                            uploadFiles(
                                                                projectId,
                                                                filesList.current,
                                                                "",
                                                                reload,
                                                                pushNotification,
                                                            )
                                                                .then(() => {
                                                                    showLinearProgress.current =
                                                                        !showLinearProgress.current;
                                                                    setUploadInProgress(false);
                                                                    if (filesList?.current) {
                                                                        filesList.current = [];
                                                                    }
                                                                    pop && pop(id);
                                                                })
                                                                .catch(() => {
                                                                    pushNotification({
                                                                        message: i18n`Something went wrong`,
                                                                        type: "error",
                                                                        open: true,
                                                                        timeout: "medium",
                                                                    });
                                                                });
                                                        }}
                                                        startIcon={<Upload />}
                                                    />
                                                </SovosButtonsGroup>
                                            </SovosDrawerHeader>
                                        </SovosBox>
                                    );
                                },
                            })
                                .then(() => {
                                    reload && reload();
                                })
                                .catch(() => null);
                        }}
                    />
                </>
            ) : null}
        </>
    );
};

export default UploadFormHeaderButtons;
